import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Image from './../../image/Image';

class GalleryImages extends Component {
  componentDidMount() {
    this.toggleArrow(true);
  }

  toggleArrow = (firstLoad = false) => {
    const {
      scrollTop,
      scrollHeight,
      clientHeight,
    } = this.refs.galleryWrapper;

    if (scrollTop > 0) {
      this.props.toggleTopArrow(true);
    }

    if (scrollTop === 0) {
      this.props.toggleTopArrow(false);
    }

    if (firstLoad) {
      this.props.toggleBottomArrow(true);
    } else if (scrollTop + clientHeight !== scrollHeight) {
      this.props.toggleBottomArrow(true);
    }
  }

  renderImages = () => {
    const { images, currentPage } = this.props;
    return images.map((image, index) => (<Image key={`key_${index}`} image={image} currentPage={currentPage} category={image.name} thumb={image.previewUrl} id={image.id} />));
  }

  render() {
    return (
      <div className="GalleryWrapper" ref="galleryWrapper" onScroll={() => this.toggleArrow()}>
        { this.renderImages()}
      </div>
    );
  }
}

GalleryImages.defaultProps = {
  images: [],
  currentPage: {},
  toggleTopArrow: () => {},
  toggleBottomArrow: () => {},
};

GalleryImages.propTypes = {
  images: PropTypes.array,
  currentPage: PropTypes.object,
  toggleTopArrow: PropTypes.func,
  toggleBottomArrow: PropTypes.func,
};

export default GalleryImages;



// WEBPACK FOOTER //
// ./src/components/gallery/gallery-images/GalleryImages.jsx